module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tw-text-blue-500 tw-font-thin ellipsis tw-text-2xl tw-uppercase"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-749c75c2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/Title/Title.vue.html
// module id = gPBb
// module chunks = 2